export default function TrustStrip() {
  const items = [
    "Woningen",
    "Kantoren",
    "Winkels",
    "Horeca",
    "Praktijkruimtes",
    "Showrooms",
  ];
  return (
    <section
      className="relative py-10 md:py-14 border-y border-white/5 bg-black/40"
      data-testid="trust-strip"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center gap-6 md:gap-12 justify-between">
        <p className="text-sm md:text-base text-zinc-400 font-body text-center md:text-left">
          <span className="text-white font-medium">
            Smart surfaces for modern spaces
          </span>{" "}
          — voor woningen, kantoren, winkels, horeca en praktijkruimtes.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-[11px] uppercase tracking-[0.25em] text-zinc-500">
          {items.map((i) => (
            <span key={i} className="opacity-70 hover:opacity-100 transition">
              {i}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
